//React
import React from 'react';
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';

//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Divider from '@material-ui/core/Divider';
import Slide from '@material-ui/core/Slide';
//Action
import * as helpAction from '../action/helpAction';
//Part
import PartUrl2Button from './PartUrl2Button';
//Icon
import CloseIcon from '@material-ui/icons/Close';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      helpList: [],
      helpVisible: false,
  	}
  }

  _renderCategoryChild(value, index, arr) {
    return (
      <span key={index} className='i-b' style={{margin:'3px'}}>
        <Button
          variant="outlined"
          color="primary"
          onClick={ () => this.props.helpOpen('category', value.help_category_name_en) }
        >
          {value.help_category_name}
        </Button>
      </span>
    )
  }

  _renderList(value, index, arr) {
    return (

      <div key={index}>
        <div
          onClick={ () => this.props.helpAnswerToggle(value.id) }
          style={{
            fontSize:'1.2em',
            fontWeight:'bold',
            padding:'5px',
            cursor: 'pointer',
          }}
        >
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              textAlign:'left',
              justifyContent:'space-between',
            }}
          >
            <div style={{color:'#666'}}>
              {value.question}
            </div>
            <div>
            {
              (value.answerVisible) ?
              <ArrowDropDownIcon /> :
              <ArrowRightIcon />
            }
            </div>
          </div>


        </div>
        {
          (value.answerVisible) &&
          <div style={{margin:'5px', color:'#333', whiteSpace: 'pre-line'}} >
            {
              (value.type === 'html') ? (
                <div
                  dangerouslySetInnerHTML={{__html: value.answer}}
                />
              ): (
                <PartUrl2Button text={value.answer} buttonClick={ () => this.props.helpClose() }/>
              )
            }
          </div>
        }
        {
          (arr.length - 1 > index) &&
          <Divider />
        }
      </div>
    )
  }

	render() {
		return (
      <Dialog
        fullScreen
        open={this.props.help.visible}
        TransitionComponent={Transition}
        style={{maxWidth:'600px', margin:'auto'}}
        scroll='paper'
      >
        <div style={{width:'100%'}} className='shadow'>
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              textAlign:'center',
              alignItems:'center',
              justifyContent:'space-between',
            }}
          >
            <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
              { (this.props.help.title) ? this.props.help.title : 'ヘルプ' }

            </div>
            <div>
              <IconButton onClick={ () => this.props.helpClose() }>
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </div>
        <DialogContent style={{padding:'10px'}}>
          {
            (this.props.help.categoryParent) ? (
              <span className='i-b' style={{margin:'3px'}}>
                <IconButton onClick={ () => this.props.helpOpen('category', this.props.help.categoryParent) }>
                  <ArrowBackIosIcon />
                </IconButton>
              </span>
            ): (
              null
            )
          }
          {
            this.props.help.categoryChild.map(
              (value, index, arr) => this._renderCategoryChild(value, index, arr)
            )
          }

          {
            this.props.help.list.map((value, index, arr) =>
              this._renderList(value, index, arr)
            )
          }
        </DialogContent>

      </Dialog>
		)
	}
}


const mapStateToProps = (state) => {
	return {
    help: state.help,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Comp));
